<template>
    <div class="recordList">
        <el-table
            :data="tableData"
            style="width: 100%">
            <el-table-column
                prop="created_time"
                :label="$t('intercept_order.date')"
                width="180">
            </el-table-column>
            <el-table-column
                prop="creator"
                :label="$t('intercept_order.userName')"
                width="180">
            </el-table-column>
            <el-table-column
                prop="operate"
                :label="$t('intercept_order.progress')">
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
export default {
    name: 'order_verify',
    props:{
        logRow: Object,
    },
    data(){
        return {
            tableData: []
        }
    },

    mounted() {
        this.tableData = this.logRow
    },

    methods:{
        hideDialog() {
            this.$emit('hideLog')
        }
    }
}
</script>

<style  lang="less" scoped>
.recordList{
    max-height: 400px;
    overflow-y: auto;
}
</style>